import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/ArrowIcon.svg";
import styles from "./styles";
import { isEmpty } from "lodash";
import { getImageSrc } from "../../../../utils/CommonFunction";

const InclusionVariantList = ({ packageDetails }) => {
  const [expandedMilestones, setExpandedMilestones] = useState(
    packageDetails?.inclusions?.map((item) => item.id) || []
  );

  const toggleMilestone = (milestoneId) => {
    setExpandedMilestones((prevExpanded) =>
      prevExpanded.includes(milestoneId)
        ? prevExpanded.filter((id) => id !== milestoneId)
        : [...prevExpanded, milestoneId]
    );
  };

  return (
    <>
      {!isEmpty(packageDetails?.inclusions) && (
        <>
          <h3 style={styles.sub_heading}>Inclusion & Variant Items</h3>
          <div style={{ ...styles.columnFlex }}>
            {packageDetails?.inclusions?.map((item) => (
              <div key={item.id}>
                <div
                  style={{
                    ...styles.rowFlex,
                    justifyContent: "space-between",
                    borderRadius: "12px",
                    background: "#F7F7F7",
                    padding: "1vh 1vw",
                    alignItems: "center",
                  }}
                >
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <Box display="flex" alignItems="center">
                      <Box
                        component="img"
                        src={getImageSrc(item?.image?.path)}
                        alt="Inclusion Icon"
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: "8px",
                          border: "2px solid white",
                          boxShadow: "0px 4px 2.67px 0px #00000026",
                          marginRight: 1,
                        }}
                      />
                      <span style={styles.small_sub_heading}>{item?.name}</span>
                    </Box>
                  </div>

                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <div style={styles.small_text}>
                      <div
                        style={{
                          ...styles.rowFlex,
                          ...styles.small_sub_heading,
                        }}
                      >
                        <NewDesignIcon />
                        {item?.materialType}
                      </div>
                    </div>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Units</h3>
                    <div style={styles.small_sub_heading}>
                      {item?.materialUnit}
                    </div>
                  </div>

                  <div style={{ ...styles.columnFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Description</h3>
                    <div style={styles.small_sub_heading}>
                      {item?.description}
                    </div>
                  </div>

                  <IconButton onClick={() => toggleMilestone(item.id)}>
                    {expandedMilestones.includes(item.id) ? (
                      <KeyboardArrowUp />
                    ) : (
                      <KeyboardArrowDown />
                    )}
                  </IconButton>
                </div>

                {expandedMilestones?.includes(item.id) && (
                  <div
                    style={{
                      ...styles.columnFlex,
                      ...styles.budgetContainer,
                      gap: "15px",
                      marginBottom: "2vh",
                    }}
                  >
                    {item?.variants?.map((budgetItem) => (
                      <div
                        key={budgetItem.id}
                        style={{
                          ...styles.rowFlex,
                          gap: "0px",
                          alignItems: "flex-start",
                        }}
                      >
                        <ArrowIcon />
                        <div style={styles.budgetRow}>
                          <div style={{ ...styles.rowFlex, flex: 1.5 }}>
                            <Box display="flex" alignItems="center">
                              <Box
                                component="img"
                                src={getImageSrc(budgetItem?.image?.path)}
                                alt="Varaint Icon"
                                sx={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: "8px",
                                  border: "2px solid white",
                                  boxShadow: "0px 4px 2.67px 0px #00000026",
                                  marginRight: 1,
                                }}
                              />
                              <span style={styles.small_sub_heading}>
                                {budgetItem?.name}
                              </span>
                            </Box>
                          </div>
                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Description</h3>
                            <div style={styles.small_sub_heading}>
                              {budgetItem?.description || "-"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default InclusionVariantList;
